<script>
import AuthWrapper from '@/components/auth/AuthWrapper.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Unauthorized',
  components: {
    AuthWrapper,
  },
  computed: {
    ...mapGetters('auth', ['userRole', 'isAuthenticated']),

    /**
     * The requiresValidResetCode guard sends visitors here with ?invalid=1
     * when a password link is missing or rejected. That is a broken link, not
     * a permission problem, and it reaches people who are signed out.
     */
    isInvalidLink() {
      return Boolean(this.$route.query.invalid);
    },
  },
  methods: {
    ...mapActions('auth', ['logout']),

    goBack() {
      this.$router.go(-1);
    },

    goHome() {
      this.$router.push('/');
    },

    goToLogin() {
      this.$router.push({ path: '/login' });
    },

    goToForgotPassword() {
      this.$router.push({ path: '/forgot-password' });
    },

    async handleLogout() {
      await this.logout();
      this.$router.push({ name: 'login' });
    },
  },
};
</script>

<template>
  <AuthWrapper variant="form">
    <BCard no-body class="auth-page__card">
      <BCardBody class="auth-page__card-body">
        <div v-if="isInvalidLink" class="auth-form__result">
          <div class="auth-form__icon auth-form__icon--danger">
            <i class="ri-error-warning-line"></i>
          </div>

          <h1 class="auth-form__title">Lien invalide ou expiré</h1>
          <p class="auth-form__body">
            Ce lien n'est plus valable. Les liens de réinitialisation et
            d'activation expirent : demandez-en un nouveau pour continuer.
          </p>

          <div class="auth-form__actions">
            <button
              class="auth-form__submit auth-form__submit--ghost"
              type="button"
              @click="goToLogin"
            >
              Connexion
            </button>
            <button
              class="auth-form__submit"
              type="button"
              @click="goToForgotPassword"
            >
              Nouveau lien
            </button>
          </div>
        </div>

        <div v-else class="auth-form__result">
          <div class="auth-form__icon auth-form__icon--danger">
            <i class="ri-forbid-line"></i>
          </div>

          <h1 class="auth-form__title">Accès interdit</h1>
          <p class="auth-form__body">
            Vous n'avez pas les permissions nécessaires pour accéder à cette
            page. Contactez votre administrateur si vous pensez qu'il s'agit
            d'une erreur.
          </p>

          <div class="auth-form__actions">
            <button
              class="auth-form__submit auth-form__submit--ghost"
              type="button"
              @click="goBack"
            >
              Retour
            </button>
            <button class="auth-form__submit" type="button" @click="goHome">
              Accueil
            </button>
          </div>
        </div>
      </BCardBody>
    </BCard>
  </AuthWrapper>
</template>
